import { render, staticRenderFns } from "./BuyEggs.vue?vue&type=template&id=4fbe565f&"
import script from "./BuyEggs.vue?vue&type=script&lang=js&"
export * from "./BuyEggs.vue?vue&type=script&lang=js&"
import style0 from "./BuyEggs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports